/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { NumOnuPacoteCriteriaDto } from '../models/num-onu-pacote-criteria-dto';
import { NumOnuPacoteDto } from '../models/num-onu-pacote-dto';
import { NumOnuPacotePageDto } from '../models/num-onu-pacote-page-dto';


/**
 * Nums ONU de Pacote
 */
@Injectable({
  providedIn: 'root',
})
export class NumsOnuPacoteService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getNumsOnuPacote
   */
  static readonly GetNumsOnuPacotePath = '/nums-onu-pacote';

  /**
   * Pesquisar nums ONU de pacote.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getNumsOnuPacote()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNumsOnuPacote$Response(params?: {
    criteria?: NumOnuPacoteCriteriaDto;
  }): Observable<StrictHttpResponse<NumOnuPacotePageDto>> {

    const rb = new RequestBuilder(this.rootUrl, NumsOnuPacoteService.GetNumsOnuPacotePath, 'get');
    if (params) {
      rb.query('criteria', params.criteria, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<NumOnuPacotePageDto>;
      })
    );
  }

  /**
   * Pesquisar nums ONU de pacote.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getNumsOnuPacote$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNumsOnuPacote(params?: {
    criteria?: NumOnuPacoteCriteriaDto;
  }): Observable<NumOnuPacotePageDto> {

    return this.getNumsOnuPacote$Response(params).pipe(
      map((r: StrictHttpResponse<NumOnuPacotePageDto>) => r.body as NumOnuPacotePageDto)
    );
  }

  /**
   * Path part for operation getNumOnuPacote
   */
  static readonly GetNumOnuPacotePath = '/nums-onu-pacote/{id}';

  /**
   * Obter num ONU de pacote.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getNumOnuPacote()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNumOnuPacote$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<NumOnuPacoteDto>> {

    const rb = new RequestBuilder(this.rootUrl, NumsOnuPacoteService.GetNumOnuPacotePath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<NumOnuPacoteDto>;
      })
    );
  }

  /**
   * Obter num ONU de pacote.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getNumOnuPacote$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNumOnuPacote(params: {
    id: number;
  }): Observable<NumOnuPacoteDto> {

    return this.getNumOnuPacote$Response(params).pipe(
      map((r: StrictHttpResponse<NumOnuPacoteDto>) => r.body as NumOnuPacoteDto)
    );
  }

}
